// removed by extract-text-webpack-plugin
module.exports = {"colored-background":"colored-background___yKytL","coloredBackground":"colored-background___yKytL","map-view":"map-view___2DU5-","mapView":"map-view___2DU5-"};